<template>
  <li :id="`program-${program.id}`" class="program">
    <v-radio
      :id="`program-${program.id}`"
      :label="
        `${program.name} - ${program.description} - sessions: ${program.no_of_sessions}`
      "
      :value="program"
      color="#5FD068"
      active-class="active"
      :class="{ active: isSelected }"
    ></v-radio>
  </li>
</template>

<script>
export default {
  name: "SingleProgram",
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$emit("choose-selected-program", this.selectedProgram);
  },
  computed: {
    /**
     * Get selected program from store
     */
    selectedProgram() {
      return this.$store.getters.GET_SELECTED_PROGRAM;
    },
    /**
     * Check if there is a program selected or not and add a class 'active' to style it
     * @returns boolean
     */
    isSelected() {
      return this.selectedProgram?.id == this.program?.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.program {
  background: $white;
  outline: 1px solid $description;
  border-radius: 8px;
  font-family: $font-family;
  font-style: normal;
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  color: #061c3d;

  &:has(.active) {
    background: #e7f5e8;
    outline: 2px solid $green;
  }
}
::v-deep .v-radio {
  padding: 18px 28px 18px 18px;
  .v-input--selection-controls__input {
    margin-inline-end: 18px;
  }
  .v-label {
    line-height: 1.5625rem;
  }
}
</style>
